import {throwError as observableThrowError, Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class LojaConfigService {
  private apiUrl = environment.apiUrl;
  private lojasUrl = `${this.apiUrl}public/lojas`;
  private lojasConfigUrl = `${this.apiUrl}sistema/empresas/lojas`;

  constructor(private _http: HttpClient) {
  }

  getLoja(lojaId: string): Observable<{}> {
    return this._http.get(this.lojasUrl + '/loja/' + lojaId)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  getLojasEmpresa(empresaId): Observable<any[]> {
    return this._http.get(this.lojasUrl + '/' + empresaId)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  insertLoja(loja): Observable<{}> {
    return this._http.post(this.lojasConfigUrl, loja)
      .pipe(map((data) => {
        return <any>data;
      }));
  }

  deleteLoja(id: string): Observable<boolean> {
    return this._http.delete(this.lojasConfigUrl + '/' + id)
      .pipe(map((data) => {
        return <any>data['status'];
      }));
  }

  private handleError(error) {
    console.log(error);
    return observableThrowError(error.error || 'Server error');
  }
}
